/**
 * prompt 封装
 * @author huangyiustb
 * @modify xuxiaoyan
 * http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=75128588
 */

import { ERR_OK, logger } from '../util'


let schema = 'didibridge://BRIDGE_CALL?callback=',
    msgFrame = null

let __uid = 0

function createFrame(src) {
  let frame = document.createElement('IFRAME')
  frame.id = 'mfe-webview-util-iframe'
  frame.style.display = 'none'
  frame.src = src
  document.body.appendChild(frame)
  return frame
}

export function callIOS(fn, param, callback) {
  let id = __uid++
  let callbackName = '__bridgeCall__' + id

  let callData = JSON.stringify({
    cmd: fn,
    id,
    params: param,
    callback: callbackName
  })

  let callDataName = '__getCallData__' + id
  window[callDataName] = function () {
    delete window[callDataName]
    logger({
      pos: 'IOS_RETURN_JSON',
      callDataName
    })
    return callData
  }

  window[callbackName] = function (retData) {

    if (typeof retData === 'string') {
      try {
        retData = JSON.parse(retData)
      } catch (e) {
        retData = {}
      }
    }
    // compatibility for Fusion
    const errno = retData.errno !== undefined
                  ? retData.errno
                  : retData.errorno
    const errmsg = retData.errmsg !== undefined
                   ? retData.errmsg
                   : retData.errormsg
    
    const err = +errno !== ERR_OK
                ? { errno, errmsg }
                : null

    delete window[callbackName]

    // node style
    callback(err, retData.result || retData)
  }

  // do send
  let src = schema + callDataName
  send(src)
  logger({
    pos: 'IOS_SEND_MSG',
    src
  })
}

function send(src) {

  if (!msgFrame) {
    msgFrame = createFrame(src)
  } else {
    msgFrame.src = src
  }

}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgefinance/ios.js